/** ANS-55: the sign-in token travels in the URL fragment (`/auth/magic#cpl_…`), never in the path or query. */
export const readMagicToken = (hash: string): string | null => {
  let value: string;
  try {
    value = decodeURIComponent(hash.replace(/^#/, '').trim());
  } catch {
    return null;
  }
  return /^cpl_[A-Za-z0-9_-]{43}$/.test(value) ? value : null;
};
